$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});



$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#benefits']", function (e) {
  e.preventDefault();
  document.querySelector('#benefits').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#testimonials']", function (e) {
  e.preventDefault();
  document.querySelector('#testimonials').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.el-product-label').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});



function isAtViewportMidline(el) {
  if (!el || !el.getBoundingClientRect) return false;
  if (!$(el).is(':visible')) return false;

  const rect = el.getBoundingClientRect();
  const vw = window.innerWidth || document.documentElement.clientWidth;
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const midY = vh / 2;

  // horizontally on-screen AND the element spans the middle line
  return rect.left < vw && rect.right > 0 && rect.top < midY && rect.bottom > midY;
}

function runCounters($block) {
  $block.addClass('el-start-count');
  $block.find('.el-count-js').each(function () {
    const $c = $(this);
    const target = +($c.data('value') || 0);
    $c.prop('Counter', 0).stop(true).animate(
      { Counter: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) { $c.text(Math.ceil(now)); }
      }
    );
  });
}

function checkCountersInView() {
  $('.el-element-counter').each(function () {
    const $block = $(this);
    if ($block.hasClass('el-start-count')) return;          // only once
    if (isAtViewportMidline(this)) runCounters($block); // trigger when truly visible
  });
}

$(window).on('scroll load', checkCountersInView);


  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.el-timeline-grid-item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('el-active');
        } else {
          $(this).removeClass('el-active');
        }
    });
});











$(document).on("click", ".el-cart-button", function (e) {
    location.href="/cart";
});

$(document).on('click', '.el-element-option', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('data_tab'), 10); // 1,2,3...

  if (!tab) return;

  // Remove active from siblings
  $('.el-element-option').removeClass('el-active');

  // Add active to current
  $this.addClass('el-active');

$('.el-quantity-trigger').hide();
$('.el-quantity-trigger[data_tab="'+tab+'"]').show();
  // Target correct bundle bar (nth-child is 1-based)
  var $target = $('.kaching-bundles__bars .kaching-bundles__bar:nth-child(' + tab + ') label');

  if ($target.length) {
    $target.trigger('click');
  }
});


$(document).on('click', '.el-element-sub-option', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('sub_tab'), 10); // 1,2,3...

  if (!tab) return;

  // Remove active from siblings
  $('.el-element-sub-option').removeClass('el-active');

  // Add active to current
  $this.addClass('el-active');

$('.el-sub-trigger').hide();
$('.el-sub-trigger[sub_tab="'+tab+'"]').show();
  // Target correct bundle bar (nth-child is 1-based)
  var $target = $('.kaching-bundles__subscriptions .kaching-bundles__bar:nth-child(' + tab + ')');

  if ($target.length) {
    $target.trigger('click');
  }
});











$(document).on("click", "a[href='#show']", function (e) {
  e.preventDefault();
    $('div#reviews .el-review-slide:nth-child(3)~*').slideToggle();
    $(this).parents('.el-read-reviews').hide();
    $('.el-read-reviews:has(a[href="#hide"])').show();
});


$(document).on("click", "a[href='#hide']", function (e) {
  e.preventDefault();
    $('div#reviews .el-review-slide:nth-child(3)~*').slideToggle();
    $(this).parents('.el-read-reviews').hide();
    $('.el-read-reviews:has(a[href="#show"])').show();
});


